"use strict";

jQuery(function ($) {
  if ($('.embed-video-block').length) {
    /* Helper function to send a message to Vimeo-iframe */
    var vimeoPost = function vimeoPost(action, value, target) {
      var data = {
        method: action
      };
      if (value) {
        data.value = value;
      }
      target.contentWindow.postMessage(JSON.stringify(data), '*');
    };
    // Single video (simpler) version here: <a href="https://codepen.io/filipbech/pen/cbaxq">https://codepen.io/filipbech/pen/cbaxq</a>
    //Vimeo

    /* Grabbing objects to play with */
    var playButtons = $('.play'),
      pauseButtons = $('.pause');
    ;

    /* When clicking the playButton, send a "play"-message to given iframe*/
    playButtons.click(function () {
      var iframe = document.getElementById(this.dataset.id);
      vimeoPost('play', null, iframe);
      $(iframe).siblings('[class^="embed-video-block"]').fadeOut(400);
    });

    /* When clicking the pauseButton, send a "pause"-message to given iframe */
    pauseButtons.click(function () {
      var iframe = document.getElementById(this.dataset.id);
      vimeoPost('pause', null, iframe);
      $(iframe).siblings('[class^="embed-video-block"]').fadeIn(400);
    });
    $(".embed-video-block").each(function () {
      var iframe = $(this).find('iframe');
      if (iframe.length && typeof Vimeo !== 'undefined') {
        var player = new Vimeo.Player(iframe);
        player.on('pause', function (data) {
          $(iframe).siblings('[class^="embed-video-block"]').fadeIn(400);
        });
        player.on('ended', function (data) {
          $(iframe).siblings('[class^="embed-video-block"]').fadeIn(400);
        });
      }
    });
    $(window).bind("load resize", function () {
      var width = $(window).width();
      if (width <= 634) {
        $(".embed-video-block__play-btn-wrapper").css("display", "none");
      } else {
        $(".embed-video-block__play-btn-wrapper").css("display", "flex");
      }
    });
  }
});